import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { RidangoReduxAction, SetCustomerProfileInformation, SetProfileInformationDTO } from '@ridango/core';

import { Observable } from 'rxjs';

import { CustomerActions } from './customer.actions';
import { CustomerPartialStoreState } from './customer.reducer';
import * as CustomerSelectors from './customer.selectors';

import { CustomerRegistrationCompleteRequest, CustomerService } from '../customer.service';

@Injectable()
export class CustomerFacade {
    profile$: Observable<any> = this.store.select(CustomerSelectors.getCustomerProfile);
    profileActions$: Observable<string[]> = this.store.select(CustomerSelectors.getCustomerProfileActions);
    customerFields$: Observable<string[]> = this.store.select(CustomerSelectors.getCustomerProfileFields);
    loaded$: Observable<boolean> = this.store.select(CustomerSelectors.getCustomerLoaded);
    error$: Observable<any> = this.store.select(CustomerSelectors.getError);
    isFormSubmitted$: Observable<boolean> = this.store.select(CustomerSelectors.getIsFormSubmitted);
    isDeletionEmailSuccess$: Observable<boolean> = this.store.select(CustomerSelectors.getIsDeletionEmailSuccess);
    isDeletionSuccess$: Observable<boolean> = this.store.select(CustomerSelectors.getIsDeletionSuccess);
    passengerPermission$: Observable<boolean> = this.store.select(CustomerSelectors.getPassengerPermission);
    customerRequestAllowed$: Observable<boolean> = this.store.select(CustomerSelectors.getCustomerRequestAllowed);
    customerRequestInfo$: Observable<string> = this.store.select(CustomerSelectors.getCustomerRequestInfo);
    isEmailChangeSent$: Observable<boolean> = this.store.select(CustomerSelectors.getIsEmailChangeSent);
    isEmailChanged$: Observable<boolean> = this.store.select(CustomerSelectors.getIsEmailChanged);

    constructor(
        private store: NgRedux<CustomerPartialStoreState>,
        private actions: CustomerActions,
        private customerService: CustomerService
    ) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    getCustomerProfile() {
        this.dispatch(this.actions.getCustomerProfile());
    }

    saveCustomerProfile(setDTO: SetProfileInformationDTO | SetCustomerProfileInformation) {
        this.dispatch(this.actions.saveCustomerProfile(setDTO));
    }

    completeCustomerRegistration(payload: CustomerRegistrationCompleteRequest) {
        this.dispatch(this.actions.completeCustomerRegistration(payload));
    }

    setAvailableProfileActions(profileActions: string[]) {
        this.dispatch(this.actions.setProfileActions(profileActions));
    }

    setCustomerFields(customerFields: string[]) {
        this.dispatch(this.actions.setProfileFields(customerFields));
    }

    sendCustomerProfileDeletionEmail() {
        this.dispatch(this.actions.sendCustomerProfileDeletionEmail());
    }

    sendCustomerProfileDeletionEmailSuccess(payload: boolean) {
        this.dispatch(this.actions.sendCustomerProfileDeletionEmailSuccess(payload));
    }

    deleteProfile(token: string = '') {
        this.dispatch(this.actions.deleteCustomerProfile(token));
    }

    sendCustomerNewEmail(payload: string) {
        this.dispatch(this.actions.sendCustomerNewEmail(payload));
    }

    resetCustomerNewEmail() {
        this.dispatch(this.actions.resetCustomerNewEmail());
    }

    saveCustomerNewEmail(payload: string) {
        this.dispatch(this.actions.saveCustomerNewEmail(payload));
    }

    clearCustomerProfile() {
        this.dispatch(this.actions.clearCustomerProfile());
    }

    sendCustomerLang(payload: string) {
        this.dispatch(this.actions.sendCustomerLang(payload));
    }
    setCustomerEmail(email: string, lang: string, redirectUri: string): Observable<void> {
        return this.customerService.setCustomerEmail({ lang, email, redirectUri });
    }

    confirmCustomerEmail(code: string): Observable<void> {
        return this.customerService.confirmCustomerEmail({ code });
    }
}
